import { api } from '../../config'
import * as actionTypes from '../../actionTypes';
import ClearIcon from '@material-ui/icons/Clear';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { green } from '@material-ui/core/colors';

export const getValueApi = (path) => {
    return async dispatch => {
        await api.get(`/mycourse/list-materi?${path}`)
        .then(response => {
            // console.log(response, "LIST")
            dispatch({ type: actionTypes.SET_VALUE_MATERI, payload: response.data })
        })
        .catch(result => {
            console.log(result)
        })
    }
}

export const getDetailApi = (path) => {
    return async dispatch => {
        await api.get(`/mycourse/detail?${path}`)
        .then(response => {
            // console.log(response, "DETAIL")
            // console.log(response.data.data.step, "DETAILS")
            if(response.data.success){
                localStorage.setItem('babaRedirect', window.location.href)
                // console.log(window.location.href, "SS")
                window.location.href = response.data.data.url
                // dispatch({ type: actionTypes.SHOW_MODAL, payload: {
                //     title: 'Perhatian',
                //     body: 'Sebelum melanjutkan belajar, kirimkan screenshot bukti kamu berhasil vermuk dan upload ke dalam aplikasi kami',
                //     redirect: response.data.data.url,
                // }})
                // localStorage.setItem('babaRedirect', window.location.href)
            } else {
                if(response.data.status !== true){
                    dispatch({ type: actionTypes.SHOW_MODAL, payload: {
                        title: 'Perhatian',
                        body: response.data.message ? response.data.message : 'Mohon maaf terjadi kesalahan.',
                        redirect: '/my-course',
                        cs: true
                    }})
                } else {
                    dispatch({ type: actionTypes.SET_DETAIL_MATERI, payload: response.data.data })
                    if(response.data.data.isNewCourse === 1){
                        if(response.data.data.course.type === 'hybrid'){
                            if(response.data.data.step === 1){
                                const set = response.data.data.isJoinWebinar ? new Set([1]) : new Set()
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                            if(response.data.data.step === 2){
                                const set = new Set([0])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 1, newSet: set})
                            }
                            if(response.data.data.step === 3){
                                const set = new Set([0, 1])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 2, newSet: set})
                            }
                            if(response.data.data.step === 4){
                                const set = new Set([0, 1, 2])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 3, newSet: set})
                            }
                            if(response.data.data.step === 5){
                                const set = new Set([0, 1, 2, 3])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 4, newSet: set})
                            }
                            if(response.data.data.step === 6){
                                const set = new Set([0, 1, 2, 3, 4])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                            if(response.data.data.step === 7){
                                const set = new Set([0, 1, 2, 3, 4])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                        } else {
                            if(response.data.data.step === 1){
                                const set = response.data.data.isJoinWebinar ? new Set([1]) : new Set()
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                            if(response.data.data.step === 2){
                                const set = response.data.data.isJoinWebinar ? new Set([1]) : new Set()
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                            if(response.data.data.step === 3){
                                const set = new Set([0])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 1, newSet: set})
                            }
                            if(response.data.data.step === 4){
                                const set = response.data.data.isDoneReflectiveJournal ? new Set([0, 1, 2]) : new Set([0, 1])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: response.data.data.isDoneReflectiveJournal ? 3 : 2, newSet: set})
                            }
                            if(response.data.data.step === 5){
                                const set = response.data.data.isDoneReflectiveJournal ? new Set([0, 1, 2, 3]) : new Set([0, 1, 3])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: response.data.data.isDoneReflectiveJournal ? 4 : 3, newSet: set})
                            }
                            if(response.data.data.step === 6){
                                const set = response.data.data.isDoneReflectiveJournal ? new Set([0, 1, 2, 3, 4]) : new Set([0, 1, 3, 4])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                            if(response.data.data.step === 7){
                                const set = response.data.data.isDoneReflectiveJournal ? new Set([0, 1, 2, 3, 4]) : new Set([0, 1, 3, 4])
                                dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                            }
                        }
                    } else {
                        if(response.data.data.step === 1){
                            const set = response.data.data.isJoinWebinar ? new Set([1]) : new Set()
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                        }
                        if(response.data.data.step === 2){
                            const set = response.data.data.isJoinWebinar ? new Set([1]) : new Set()
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                        }
                        if(response.data.data.step === 3){
                            const set = new Set([0])
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 1, newSet: set})
                        }
                        if(response.data.data.step === 4){
                            const set = new Set([0, 1])
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 2, newSet: set})
                        }
                        if(response.data.data.step === 5){
                            const set = new Set([0, 1, 2])
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                        }
                        if(response.data.data.step === 6){
                            const set = new Set([0, 1, 2])
                            dispatch({ type: actionTypes.SET_STEP_FROM_API, step: 0, newSet: set})
                        }
                    }
                    
                    if(response.data.data.userReview !== null){
                        api.get(`rating/show?id=${response.data.data.userReview}`)
                            .then(response => {
                                // console.log(response)
                                dispatch({ type: actionTypes.SET_REVIEW, payload: response.data.data})
                            })
                            .catch(response => {
                                console.log(response)
                            })
                    }
                }
            }
        })
        .catch(err => {
            console.log(err)
            dispatch({ type: actionTypes.SHOW_MODAL, payload: {
                title: 'Perhatian',
                body: `${err.response.data.message ? err.response.data.message : 'Mohon maaf terjadi kesalahan.'}. Silahkan hubungi admin.`,
                redirect: '/my-course',
                cs: true,
            }})
        })
    }
}

export const getWebinarInfo = (path) => {
    return async dispatch => {
        await api.get(`/mycourse/webinar-info/?course_id=${path}`)
        .then(response => {
            // console.log(response, "KIRI")
            dispatch({ type: actionTypes.SET_DETAIL_WEBINAR_PUBLIC, payload: response.data })
        })
        .catch(result => {
            dispatch({ type: actionTypes.SET_DETAIL_WEBINAR_PUBLIC, payload: "error" })
            console.log(result)
        })
    }
}

export const getCertificate = (path) => {
    return async dispatch => {
        await api.get(`/mycourse/certificate-info?course_id=${path}`)
            .then(response => {
                // console.log(response, "CERTIFICATE")
                if(response.data.status){
                    api.get(response.data.data.linkImage.split('/api/')[1])
                        .then(response => {
                            // console.log(response, "INI LIHAT")
                            dispatch({ type: actionTypes.SET_CERTIFICATE_IMAGE, payload: response.data })
                        })
                        .catch(response => {
                            console.log(response)
                        })
                } else {
                    return null
                }
                dispatch({ type: actionTypes.SET_CERTIFICATE, payload: response.data.data })
            })
            .catch(result => {
                console.log('GAGAL', result)
            })
    }
}


export const getCourseList = () => {
    const pathname = window.location.pathname
    const param = pathname.split('/').pop();
    return async dispatch => {
        dispatch({ type: actionTypes.SHOW_BACKDROP })
        if(param === 'my-course' || param === ''){
            await api.get(`/mycourse`)
            .then(response => {
                dispatch({ type: actionTypes.HIDE_BACKDROP })
                // console.log(response, "COURSE")
                dispatch({ type: actionTypes.SET_COURSE_LIST, payload: response.data.data.courses })
            })
            .catch(result => {
                console.log(result)
                dispatch({ type: actionTypes.HIDE_BACKDROP })
            })
        } else {
            await api.get(`course/search?${param}`)
            .then(response => {
                dispatch({ type: actionTypes.HIDE_BACKDROP })
                // console.log(response, "COURSE")
                dispatch({ type: actionTypes.SET_COURSE_LIST, payload: response.data.course })
            })
            .catch(result => {
                console.log(result)
                dispatch({ type: actionTypes.HIDE_BACKDROP })
            })
        }
    }
}

export const getAllCourses = () => {
    return async (dispatch) => {
        dispatch({ type: actionTypes.SHOW_BACKDROP });
        await api.get(process.env.REACT_APP_URI_API+'course')
        .then(({data}) => {
            sessionStorage.setItem('allCourse', JSON.stringify(data.course))
            dispatch({
                type: actionTypes.SET_ALL_COURSES,
                payload: {
                  title: 'All Courses',
                  body: data.course
                },
            });
            dispatch({ type: actionTypes.HIDE_BACKDROP });
        })
        .catch(err => {
            console.log(err)
            dispatch({ type: actionTypes.HIDE_BACKDROP });
        })
    }
}

export const setHashed = (path, selectId) => {
    return {
        type: actionTypes.SET_HASHED,
        videoLink: path,
        selectId: selectId
    }
}

export const postQuiz = (param, answer, video) => {
    return async dispatch => {
        await api.post(`/quiz/answer-quiz`, {quiz_id: param.id, answer: answer})
        .then(response => {
            dispatch({ type: actionTypes.SHOW_MODAL, payload: {
                type: "Voucher",
                title: 'Jawaban',
                body: response.data.message,
                icon: response.data.message === "Jawaban benar" ? <CheckCircleOutlineIcon style={{ fontSize: 100, color: green[500] }}/> : <ClearIcon color='error' style={{ fontSize: 100 }}/>
            }})
            video.play();
            // console.log(response);
        })
        .catch(result => {
            console.log(result)
        })
    }
}

export const setActiveStep = (param) => {
    return {
        type: actionTypes.SET_ACTIVE_STEP,
        activeStep: param,
    }
}

export const setCompleted = (param) => {
    return {
        type: actionTypes.SET_COMPLETED,
        completed: param,
    }
}

export const filterCourse = (selected) => {
    return {
        type: actionTypes.FILTER_COURSE,
        selectCourse: selected
    }
}

export const setDone = (param) => {
    return {
        type: actionTypes.SET_DONE,
        done: param,
    }
}

export const setRef = (array) => {
    return {
        type: actionTypes.SET_REF,
        refference: array,
    }
}

export const setUjian = (array) => {
    return {
        type: actionTypes.SET_UJIAN,
        payload: array,
    }
}

export const searchCourse = (value) => {
    return {
        type: actionTypes.SEARCH_VALUE,
        payload: value,
    }
}